module.exports = __webpack_public_path__ + "img/Rectangle 55(2).81210337.png";